var _path, _ellipse, _mask, _g, _path2, _mask2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _mask3, _g2, _path11, _path12, _ellipse2, _ellipse3, _ellipse4, _path13, _path14, _path15, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiving(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 109,
    viewBox: "0 0 320 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.337 44.5076C129.832 39.815 204.642 50.3153 221.84 52.1205C236.838 53.6949 201.701 55.7705 213.548 57.6768C231.197 60.5167 304.27 69.1035 268.176 71.438C232.083 73.7725 315.714 82.9987 288.662 84.503C263.953 85.8769 170.876 76.2212 144.308 75.4562C122.574 74.8305 107.938 72.7451 88.5484 71.438C65.8126 69.9053 22.9232 86.7556 11.1323 84.0153C-12.9552 79.8734 40.045 68.9436 64.2968 62.5542C88.5486 56.1649 30.642 54.0716 79.9047 52.1205C129.167 50.1695 154.841 49.2002 142.337 44.5076Z",
    fill: "#DEFBFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.029,
    cy: 84.3081,
    rx: 55.7468,
    ry: 5.60135,
    fill: "#6B9EDA"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 13,
    width: 130,
    height: 77
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.8174 13.0911H213.315C217.711 40.8254 207.359 60.7517 189.309 83.7748C184.241 91.2433 119.426 91.7768 113.557 82.9746C90.8601 60.1938 85.974 44.4435 85.8174 13.0911Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.003 61.6185L112.393 61.1357L112.594 59.6775C115.236 40.4437 131.74 25.6274 151.7 25.6274C173.502 25.6274 191.176 43.3015 191.176 65.1036C191.176 86.9057 173.502 104.58 151.7 104.58C132.294 104.58 116.154 90.5746 112.845 72.1199L112.585 70.6711L111.176 70.2455C109.311 69.6819 107.956 67.9479 107.956 65.9038C107.956 63.9244 109.226 62.2353 111.003 61.6185Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 4.80116
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.505,
    cy: 51.7671,
    r: 4.53443,
    fill: "#003792"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.433,
    cy: 51.7671,
    r: 4.53443,
    fill: "#003792"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.727 72.7971C171.516 73.1591 173.484 70.9578 192.087 72.7971C230.411 70.2721 205.257 77.1869 238.911 77.6747C272.566 78.1625 297.399 81.0307 294.196 84.5891C291.001 88.1388 259.949 90.8096 230.685 92.3422C203.957 93.742 267.278 96.2399 204.281 99.6233C141.284 103.007 83.1411 97.562 100.39 92.3422C117.64 87.1225 23.5083 86.7797 10.7535 83.9877C-2.09782 81.1746 10.1602 77.7201 22.0728 74.8574C33.0008 72.2313 52.9156 70.3247 74.4673 68.6765C95.5826 67.0618 121.238 72.425 146.727 72.7971Z",
    fill: "#DEFBFF"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 68,
    width: 290,
    height: 26
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.727 72.7971C171.516 73.1591 182.824 68.6911 201.428 70.5303C217.653 72.1343 232.956 73.6407 245.771 75.5829C264.863 78.4763 297.399 81.0307 294.196 84.5892C291.001 88.1388 259.949 90.8096 230.685 92.3423C203.957 93.742 172.806 93.2311 144.066 92.4518C120.555 91.8142 104.722 89.6895 83.7477 88.3578C59.1534 86.7963 23.5083 86.7797 10.7535 83.9877C-2.09782 81.1746 10.1602 77.7201 22.0728 74.8574C33.0008 72.2313 52.9156 70.3247 74.4673 68.6765C95.5826 67.0618 121.238 72.425 146.727 72.7971Z",
    fill: "#DEFBFF"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.58 89.8685C175.208 89.8685 193.551 78.2038 193.551 69.8594C193.551 61.515 175.208 54.7505 152.58 54.7505C135.988 54.7505 121.699 58.3877 115.257 63.618C110.418 64.1201 106.731 66.7081 106.731 69.8253C106.731 73.2048 111.064 77.8914 116.502 78.1512C123.424 84.3273 136.984 89.8685 152.58 89.8685Z",
    fill: "#C0D9E8"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.048 9.89014C164.048 9.89014 196.856 50.4333 198.189 63.7698C199.523 77.1063 175.769 69.9046 175.769 69.9046",
    stroke: "#003792",
    strokeWidth: 9.60232,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.497 50.9666C132.415 52.1035 119.401 55.2484 112.057 60.2826",
    stroke: "#003792",
    strokeWidth: 4.80116
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148.194 36.2985C141.802 37.0643 137.37 43.046 138.497 49.3835L140.297 59.503C141.158 64.344 145.92 67.4583 150.701 66.306L155.823 65.0712C158.644 64.3911 160.622 62.2642 162.119 60.5526C162.347 60.2925 162.565 60.0403 162.776 59.7965C164.115 58.2478 165.161 57.0397 166.426 56.3229C166.744 56.1428 167.163 55.9774 167.717 55.8672C168.002 55.8107 168.258 55.7815 168.488 55.7723C170.109 55.7071 171.853 56.3756 174.138 57.2515C174.358 57.3359 174.583 57.4222 174.814 57.51C177.142 58.3963 180.178 59.4893 183.192 58.65L186.167 57.8213C190.467 56.6236 193.118 52.3148 192.249 47.9364L190.988 41.5883C189.848 35.8466 184.479 31.9507 178.667 32.6471L148.194 36.2985Z",
    fill: "#003792",
    stroke: "#003792",
    strokeWidth: 4.2677
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.916 53.9519L199.836 47.5856L197.013 54.1289L189.274 58.7371L186.916 53.9519Z",
    fill: "#003792"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M156.253 63.8728L162.658 58.2314L165.933 61.9506L159.856 65.5862L156.253 63.8728Z",
    fill: "#003792"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.321 36.1638L149.86 31.6755L151.324 34.9385L145.247 38.5741L142.321 36.1638Z",
    fill: "#003792"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154.994 32.2065C148.603 32.9723 144.17 38.9539 145.298 45.2914L147.098 55.411C147.959 60.2519 152.721 63.3662 157.501 62.214L162.624 60.9792C165.445 60.2991 167.422 58.1722 168.92 56.4606C169.147 56.2005 169.366 55.9483 169.576 55.7045C170.916 54.1558 171.961 52.9477 173.227 52.2309C173.545 52.0508 173.963 51.8853 174.518 51.7751C175.103 51.659 175.571 51.6574 175.945 51.7108C177.366 51.914 178.76 52.6329 180.542 53.5512C180.838 53.7039 181.144 53.862 181.464 54.0242C183.472 55.0441 186.07 56.2613 188.917 55.8526L192.237 55.376C197.094 54.6789 200.364 50.0407 199.39 45.2322L197.813 37.4497C196.654 31.7288 191.296 27.8567 185.5 28.5512L154.994 32.2065Z",
    fill: "#90D7FF",
    stroke: "#003792",
    strokeWidth: 4.2677
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 26,
    width: 54,
    height: 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.399 44.9177C146.486 39.7874 150.074 34.9451 155.248 34.3252L185.722 30.6738C190.427 30.11 194.773 33.2638 195.696 37.9119L196.957 44.26C197.609 47.5438 195.62 50.7754 192.395 51.6736L189.42 52.5024C184.933 53.752 179.856 49.3612 175.203 49.5481C174.856 49.5621 174.489 49.6054 174.103 49.6822C173.345 49.8326 172.709 50.0719 172.175 50.3741C168.44 52.4899 166.297 57.8987 162.124 58.9048L157.001 60.1395C153.416 61.0037 149.844 58.668 149.198 55.0373L147.399 44.9177Z",
    fill: "#6B9EDA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 159.396,
    y: 27.8264,
    width: 6.84368,
    height: 33.0121,
    transform: "rotate(18.7686 159.396 27.8264)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 167.46,
    y: 30.5271,
    width: 3.10898,
    height: 34.9742,
    transform: "rotate(18.7686 167.46 30.5271)",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M287.233 50.6898C287.233 53.046 273.881 41.7137 266.139 44.8554C258.398 47.997 251.105 50.3532 251.104 46.4262C251.104 42.4991 261.09 36.6646 271.076 38.0111C281.062 39.3575 287.233 48.6702 287.233 50.6898Z",
    fill: "#6B9EDA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M289.931 54.3989C289.931 54.3989 294.007 60.6482 292.905 57.0974C291.803 53.5465 287.375 49.6976 286.497 49.9704C285.618 50.2432 288.621 54.5344 289.723 58.0852C291.277 61.79 290.481 54.5864 289.931 54.3989Z",
    fill: "#6B9EDA"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.088,
    cy: 43.4758,
    rx: 1.23421,
    ry: 0.448805,
    transform: "rotate(-28.074 254.088 43.4758)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.94,
    cy: 38.8642,
    rx: 3.81484,
    ry: 0.897609,
    transform: "rotate(-29.2723 261.94 38.8642)",
    fill: "#6B9EDA"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.887,
    cy: 45.423,
    rx: 3.81484,
    ry: 0.897609,
    transform: "rotate(0.102212 262.887 45.423)",
    fill: "#6B9EDA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3373 93.6968C72.5878 98.7237 131.606 101.086 136.848 103.717C142.09 106.348 71.0081 97.7303 79.6784 95.3669C88.3488 93.0034 29.8384 91.554 26.4179 89.2852C22.9973 87.0165 33.7471 87.9669 41.5652 89.2852C43.9658 89.69 63.4589 91.2149 66.9741 91.5116C74.9065 92.1813 94.3373 92.6316 94.3373 93.6968Z",
    fill: "#DEFBFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.88 76.2115C306.329 76.2115 315 75.1196 315 73.7727C315 72.4258 305.719 71.334 294.271 71.334C282.822 71.334 264.762 72.4258 264.762 73.7727C264.762 74.7698 271.711 75.0925 282.395 75.5887C286.144 75.7627 290.352 75.9581 294.88 76.2115ZM293.661 74.9921C302.752 74.9921 310.122 74.3097 310.122 73.4679C310.122 72.6261 302.752 71.9437 293.661 71.9437C284.569 71.9437 277.199 72.6261 277.199 73.4679C277.199 74.3097 284.569 74.9921 293.661 74.9921Z",
    fill: "#DEFBFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.593 74.5258C300.654 74.5258 305.245 73.9478 305.245 73.2347C305.245 72.5216 300.331 71.9436 294.27 71.9436C288.209 71.9436 283.296 72.5216 283.296 73.2347C283.296 73.9478 288.532 74.5258 294.593 74.5258ZM294.109 73.8803C298.12 73.8803 301.371 73.519 301.371 73.0734C301.371 72.6277 298.12 72.2664 294.109 72.2664C290.098 72.2664 286.846 72.6277 286.846 73.0734C286.846 73.519 290.098 73.8803 294.109 73.8803Z",
    fill: "#DEFBFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H320V109H0V0Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiving);
export default __webpack_public_path__ + "static/media/diving.615ebb0c.svg";
export { ForwardRef as ReactComponent };